import { verifiers, accessors } from '@yola/subscription-manager-js';

function isFreeDomainAvailable(activeSubscriptions, allSubscriptionsList, isFreeDomainEnabled) {
  const hasAnnualPaidHostingSubscription =
    verifiers.hasAnnualPaidHostingSubscription(activeSubscriptions);
  const hasEverHadDomainSubscription = allSubscriptionsList.some(({ type }) =>
    verifiers.isDomainPackageType(type)
  );
  const activeHostingSubscription = accessors.getActiveHostingSubscription();

  const isTrialSubscription =
    activeHostingSubscription && verifiers.isTrialSubscription(activeHostingSubscription);

  return (
    Boolean(isFreeDomainEnabled) &&
    hasAnnualPaidHostingSubscription &&
    !isTrialSubscription &&
    !hasEverHadDomainSubscription
  );
}

export default isFreeDomainAvailable;
